// extracted by mini-css-extract-plugin
module.exports = {"footer":"RulesListTableFooter_footer__2HKrB","addButton":"RulesListTableFooter_addButton__2I_l-"};